/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchComparablePropertyRecurringCostItemDto
 */
export interface PatchComparablePropertyRecurringCostItemDto {
    /**
     * 
     * @type {string}
     * @memberof PatchComparablePropertyRecurringCostItemDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof PatchComparablePropertyRecurringCostItemDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchComparablePropertyRecurringCostItemDto
     */
    frequency: string;
    /**
     * 
     * @type {string}
     * @memberof PatchComparablePropertyRecurringCostItemDto
     */
    type: string;
}

/**
 * Check if a given object implements the PatchComparablePropertyRecurringCostItemDto interface.
 */
export function instanceOfPatchComparablePropertyRecurringCostItemDto(value: object): value is PatchComparablePropertyRecurringCostItemDto {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PatchComparablePropertyRecurringCostItemDtoFromJSON(json: any): PatchComparablePropertyRecurringCostItemDto {
    return PatchComparablePropertyRecurringCostItemDtoFromJSONTyped(json, false);
}

export function PatchComparablePropertyRecurringCostItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchComparablePropertyRecurringCostItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'] == null ? undefined : json['value'],
        'frequency': json['frequency'],
        'type': json['type'],
    };
}

export function PatchComparablePropertyRecurringCostItemDtoToJSON(json: any): PatchComparablePropertyRecurringCostItemDto {
    return PatchComparablePropertyRecurringCostItemDtoToJSONTyped(json, false);
}

export function PatchComparablePropertyRecurringCostItemDtoToJSONTyped(value?: PatchComparablePropertyRecurringCostItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
        'frequency': value['frequency'],
        'type': value['type'],
    };
}

